import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SearchIcon } from 'components/Icons';
import { I18nContext } from 'components/I18n';
import { StyledSearchLink } from './Styles';

function SearchLink({ onClick, iconSize }) {
  const searchMenu = useSelector(state => state.settings.searchMenu);
  const label = searchMenu.title;
  const i18nContext = useContext(I18nContext);

  return (
    <StyledSearchLink
      onClick={onClick}
      to={{ name: 'search' }}
      data-content={label}
      aria-label={i18nContext.formatText('search')}
    >
      <SearchIcon size={iconSize} />
    </StyledSearchLink>
  );
}

SearchLink.propTypes = {
  onClick: PropTypes.func,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default React.memo(SearchLink);
